









































































































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import {InventoryItem, ItemType, Room} from '@/store/types'
import {AppHeader, Touch, ListItemRound} from '@/components/common'
import {
  InventoryAddMultipleItemsOverlay,
  InventoryEditItemOverlay,
  InventoryItemsList,
  InventoryItemRound,
  InventoryNewItemOverlay,
} from '@/components/inventory'
import Fuse from 'fuse.js'

@Component({
  components: {
    AppHeader,
    ListItemRound,
    InventoryAddMultipleItemsOverlay,
    InventoryNewItemOverlay,
    InventoryEditItemOverlay,
    InventoryItemsList,
    InventoryItemRound,
    Touch,
  },
})
export default class ItemsList extends Vue {
  @Getter('roomInventory') public roomInventory!: InventoryItem[]
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('activeRoomId') public activeRoomId!: number
  @Getter('activeRoom') public activeRoom!: Room
  @Getter('activeGroups') public activeGroups!: any
  @Getter('showInventoryNewItemOverlay') public showInventoryNewItemOverlay!: boolean
  @Getter('itemTypes') public itemTypes!: ItemType[]
  @Getter('showInventoryEditItemOverlay') public showInventoryEditItemOverlay!: boolean
  @Getter('showInventoryItemList') public showInventoryItemList!: boolean
  @Getter('showInventoryAddMultipleItemsOverlay') public showInventoryAddMultipleItemsOverlay!: boolean
  @Getter('addedItemTransition') public addedItemTransition!: boolean
  @Getter('activeItemType') public activeItemType!: ItemType
  @Mutation('setActiveRoomId') public setActiveRoomId!: any
  @Mutation('setAddedItem') public setAddedItem!: any
  @Mutation('setActiveGroups') public setActiveGroups!: any
  @Mutation('setInventoryEditItemOverlay') public setInventoryEditItemOverlay!: any
  @Mutation('setActiveItem') public setActiveItem!: any
  @Mutation('setInventoryItemList') public setInventoryItemList!: any
  @Mutation('setAddedItemTransition') public setAddedItemTransition!: any
  @Mutation('setActiveItemType') public setActiveItemType!: any
  @Mutation('setInventoryNewItemOverlay') public setInventoryNewItemOverlay!: any
  @Mutation('setInventoryAddMultipleItemsOverlay') public setInventoryAddMultipleItemsOverlay!: any
  @Action('addRoomItem') public addRoomItem!: any
  @Action('openInventoryAddedItem') public openInventoryAddedItem!: any

  public searchText: string = ''
  public $refs: any
  public activeGroup: number = 0

  public get filteredItems() {
    if (this.searchText.length) {
      const fuse = new Fuse(this.itemTypes, {distance: 100, threshold: 0.2, keys: ['name']})
      const items = fuse.search(this.searchText)
      if (items.length) {
        return items
      } else {
        return [
          { name: this.searchText, custom: true, id: 1, volume: 1, image: 'icon_none.png' },
        ]
      }
    } else {
      return this.itemTypes
    }
  }

  public get activeRoomName() {
    if (this.activeRoom) {
      return !!this.activeRoom.name ? this.activeRoom.name : this.activeRoom.room.name
    }
  }

  public closeKeyboard() {
    (document.activeElement as HTMLElement).blur()
  }

  public get items() {
    return this.activeRoomId ? this.roomInventory : this.inventory
  }

  public editItem(item: InventoryItem) {
    this.setActiveItem(item)
    this.setInventoryEditItemOverlay(true)
  }

  public listItem() {
    this.setInventoryEditItemOverlay(false)
    this.setInventoryItemList(true)
  }

  public active(item: ItemType) {
    if (this.activeItemType) {
      return this.activeItemType.id === item.id
    }

    return false
  }

  public openAccordion(e: any, index: number) {
    window.scrollTo(0, (100 + index * 70))
  }

  public selectInput() {
    const activeSearch = document.activeElement as HTMLInputElement
    setTimeout(() => {
      activeSearch.selectionStart = activeSearch.selectionEnd = 99999
    }, 1)
  }

  public clearSearch() {
    this.searchText = ''
    this.$refs.search.focus()
  }

  public openGroup(id: number, index: number, e: any) {
    if (this.activeGroup === id) {
      this.activeGroup = 0
    } else {
      this.activeGroup = id
    }

    this.$nextTick(() => {
      this.openAccordion(e, index)
    })
  }

  public backItemList() {
    this.setInventoryEditItemOverlay(false)
    this.setInventoryItemList(false)
  }

  public back() {
    this.setActiveRoomId(0)
    this.$router.back()
  }

  public mounted() {
    this.setInventoryItemList(false)
    this.setActiveRoomId(parseInt(this.$route.params.roomId, 10))
    this.$nextTick(() => {
      this.setActiveGroups(this.activeRoom.room_id)
      this.setAddedItemTransition(true)
      window.scrollTo(0, 0)
    })
  }
}
